module.exports = __webpack_public_path__ + "img/next.eb9d9835.svg";